import { api } from '../api'

/*

  IN THIS API IS EVERYTHING NEEDED FOR THE "CREATE PARTNER" MODAL THAT APPEARS WHEN
  YOU RIGHT CLICK THE SCREEN WHEN ON SCAN DOCUMENT TAB

*/

export const partnersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllCountries: builder.query({
      query: ({ formData }) => ({
        url: `/protocol/get-all-countries`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Partners'],
    }),
    getAllCurrencies: builder.query({
      query: ({ formData }) => ({
        url: `/protocol/get-all-currencies`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Partners'],
    }),
    getAllAgents: builder.query({
      query: ({ formData }) => ({
        url: `/protocol/get-all-agents`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Partners'],
    }),
    getAllPartnerGroups: builder.query({
      query: ({ formData }) => ({
        url: `/protocol/get-all-partner-groups`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Partners'],
    }),
    getPartnerVATIDConfig: builder.query({
      query: ({ formData }) => ({
        url: `/protocol/get-partner-config`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Partners'],
    }),
    createPartner: builder.mutation({
      query: ({ formData }) => ({
        url: `/protocol/create-partner`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Partners'],
    }),
  }),
})

export const {
  useGetPartnerVATIDConfigQuery,
  useGetAllCountriesQuery,
  useGetAllCurrenciesQuery,
  useGetAllAgentsQuery,
  useGetAllPartnerGroupsQuery,
  useCreatePartnerMutation,
} = partnersApi
